import { PlotObject } from './PlotObject';
import { PlotCoreObject } from '@core_n/asp/PlotCoreObject';
import { PlotsCorePool } from '@core_n/asp/PlotsCorePool';
import { IMapMngr } from '@core_n/asp/interfaces';
import { AspObject } from '@core_n/asp/AspObject';
import { AppInjector } from '@core_n/common/inject';
import { AroPlotService } from '../aro/aro-plot.service';
import { ProjConstants } from '../common/projConsts';
import * as projConsts from '../common/projConsts';
import * as settings from '../../core/app/common/settings';
import * as enums from '../../core/app/common/enums';

export class PlotsPool extends PlotsCorePool {

  protected createPlot(sensorID: number, sensorPlotID: number, correlated: boolean): PlotCoreObject {
    return new PlotObject(this, sensorID, sensorPlotID, correlated);
  }


  handleUserAction(action: number, obj: AspObject, mapMngr: IMapMngr): boolean {
    if (action == projConsts.USER_ACTION_SHOW_ARO && this.getSlotAge(obj.slotNumber) < settings.userSettings.plotTrailLength) {
      if (settings.userSettings.userPerm == enums.Permission.USER)
        return true;
      let trk = obj as PlotObject;
      AppInjector.get(AroPlotService).showPlot(trk);
      return true;
    }
    else
      return super.handleUserAction(action, obj, mapMngr);
  }
}
